import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { demoPhone, demoSiteUrl } from '../../data/websites';
export function TryItNow() {
  return <section aria-labelledby="try-it-now" className="bg-brand-red px-[clamp(1rem,4vw,6rem)] py-20 lg:py-28" data-id="element-896" data-mp="2a8gih7h0zd2f">
      <div className="grid items-center gap-10 lg:grid-cols-2 xl:gap-20" data-id="element-897" data-mp="1ve1uesiltdgw">
        <div data-id="element-898" data-mp="209h7hi8sf5c9">
          <p className="text-sm font-bold uppercase tracking-[0.14em] text-white/80" data-id="element-899" data-mp="2097i9wvkh27m">Try it right now</p>
          <h2 id="try-it-now" className="mt-3 text-[clamp(2rem,3.2vw,3.75rem)] font-extrabold leading-tight tracking-tight text-white" data-id="element-900" data-mp="1mhki3lyi79jk">
            Don’t take our word for it. Change our website.
          </h2>
          <p className="mt-6 max-w-[58ch] text-[clamp(1.0625rem,1.2vw,1.375rem)] leading-relaxed text-white/90" data-id="element-901" data-mp="1hk12ahm5qopi">
            Call {demoPhone.display} and change the wording on our demo site,{' '}
            <a href={demoSiteUrl} target="_blank" rel="noopener noreferrer" className="font-bold text-white underline underline-offset-4 hover:text-brand-light" data-id="element-902" data-mp="17mwfqgoegr86">
              tacotruck.adroimarketing.com
            </a>
            . Pick a line of text, tell Ava what it should say, then refresh a few minutes later and watch it change.
          </p>
        </div>

        <div className="lg:justify-self-end" data-id="element-903" data-mp="24qrzj79vrz91">
          <a href={demoPhone.tel} className="inline-flex items-center gap-4 rounded-xl bg-brand-black px-8 py-6 text-white transition-colors duration-150 ease-out hover:bg-[#1f1f1f] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-brand-red" data-id="element-904" data-mp="1h0egg699xaql">
            <span className="flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-full bg-brand-red" data-id="element-905" data-mp="1ly676wy6mqt7">
              <PhoneIcon className="h-6 w-6" aria-hidden="true" data-id="element-906" data-mp="y8bxupd2nkdp" />
            </span>
            <span data-id="element-907" data-mp="tak3looyfm6c">
              <span className="block text-sm font-semibold text-gray-400" data-id="element-908" data-mp="t8zam3iagbal">Call the demo line</span>
              <span className="block whitespace-nowrap text-[clamp(1.75rem,2.6vw,3rem)] font-extrabold leading-tight" data-id="element-909" data-mp="1ix4q510ffrod">
                {demoPhone.display}
              </span>
            </span>
          </a>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-white/80" data-id="element-910" data-mp="1rtvgqxw7mebk">
            One demo per caller. Demo changes are text only. The demo site resets every night at midnight.
          </p>
        </div>
      </div>
    </section>;
}